import * as breakpoints from "../../styles/breakpoints";
import * as colors from "../../styles/colors";
import * as routeHelpers from "../../lib/routeHelpers";
import appStyles from "../../styles/appStyles";
import { Gradient } from "./Gradient";
import { Paper } from "../Paper";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { StyleSheet, css } from "aphrodite/no-important";
import DocketNavigatorLogo from "../../images/docket-navigator-logo.svg";

const styles = StyleSheet.create({
	unauthenticated: {
		paddingBottom: 10,
		flex: 1,
		display: "flex",
		flexDirection: "column",
		overflow: "auto",
		[breakpoints.portraitTabletAndDown]: {
			paddingTop: 56,
		},
		[breakpoints.landscapeTabletAndUp]: {
			paddingTop: 68.38,
		},
	},
	header: {
		margin: 0,
		flexShrink: 0,
	},
	logo: {
		display: "block",
		marginLeft: "auto",
		marginRight: "auto",
		[breakpoints.portraitTabletAndDown]: {
			width: 320,
			height: 39.65,
		},
		[breakpoints.landscapeTabletAndUp]: {
			width: 472,
			height: 58.48,
		},
	},
	formContainer: {
		[breakpoints.portraitTabletAndDown]: {
			visibility: "hidden",
		},
		[breakpoints.landscapeTabletAndUp]: {
			visibility: "visible",
			width: 425,
			marginLeft: "auto",
			flexShrink: 0,
			marginRight: "auto",
			marginTop: 65,
			zIndex: 200,
			position: "relative",
		},
	},
	formContent: {
		visibility: "visible",
	},
	blueBox: {
		marginLeft: "auto",
		marginRight: "auto",
		[breakpoints.landscapeTabletAndUp]: {
			width: 472,
			backgroundColor: colors.docketLightishBlue,
			position: "relative",
			bottom: 166,
		},
	},
	blueBoxContent: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		zIndex: 100,
		[breakpoints.landscapeTabletAndUp]: {
			backgroundColor: colors.docketLightishBlue,
		},
	},
	link: {
		color: colors.white,
		textDecoration: "none",
		fontSize: 14,
	},
	divider: {
		width: 1,
		height: 20,
		backgroundColor: colors.white,
		marginLeft: 16,
		marginRight: 16,
	},
	topSpacer: {
		height: 0,
		[breakpoints.landscapeTabletAndUp]: {
			backgroundColor: colors.docketLightishBlue,
			height: 195.5,
		},
	},
	bottomSpacer: {
		height: 0,
		[breakpoints.landscapeTabletAndUp]: {
			backgroundColor: colors.docketLightishBlue,
			height: 25.5,
		},
	},
});

const inlineStyles = {
	paper: { boxShadow: "0px 19px 38px" },
};

const strings = {
	docketNavigator: "Docket Navigator",
	forgotPassword: "Forgot your password?",
	freeTrial: "Free Trial",
};

export default function Unauthenticated(props) {
	return (
		<Gradient>
			<div className={css(styles.unauthenticated)}>
				<h1 className={css(styles.header)}>
					<Link to="/">
						<img
							alt={strings.docketNavigator}
							className={css(styles.logo)}
							src={DocketNavigatorLogo}
						/>
					</Link>
				</h1>

				<Paper className={css(styles.formContainer)} style={inlineStyles.paper}>
					<div className={css(styles.formContent)}>{props.children}</div>
				</Paper>

				<div className={css(styles.blueBox)}>
					<div className={css(styles.topSpacer)} />
					<div className={css(styles.blueBoxContent)}>
						<Link
							className={css(appStyles.baseFont, styles.link)}
							to={routeHelpers.freeTrial()}
						>
							{strings.freeTrial}
						</Link>
						<div className={css(styles.divider)} />
						<Link
							className={css(appStyles.baseFont, styles.link)}
							to={routeHelpers.forgotPassword()}
						>
							{strings.forgotPassword}
						</Link>
					</div>
					<div className={css(styles.bottomSpacer)} />
				</div>
			</div>
		</Gradient>
	);
}

Unauthenticated.propTypes = {
	children: PropTypes.node.isRequired,
};
